import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  recommendationOptions: [],
  tagDecisionUsers: [],
  votingTableData: [],
  editedRows: [],
  prevTableData: [],
  prevEditedRows: [],
  saveState:true,
  decisionStepperStatus: {}
};

const decisionCentralRulesSlice = createSlice({
  name: 'decisionCentralRules',
  initialState,
  reducers: {
    setRecommendationOptions: (state, action) => {
      state.recommendationOptions = action.payload;
    },
    setTagUsers: (state, action) => {
      state.tagDecisionUsers = action.payload;
    },
    setDecisionVotingTableData: (state, action) => {      
      state.votingTableData = action.payload;
    },
    handleDecisionMakingColumnsChange: (state, action) => {
      let { value, key, id } = action.payload;
      let filteredTable = [...state.votingTableData];
      let filteredEditedRows = [...state.editedRows];
      filteredTable?.map((item) => {
        if (item.CycleSKUKey === id) {
          if (item[key] !== value) {
            filteredEditedRows.push(id);
          }
          item[key] = value;
        }
        return item;
      });
      state.votingTableData = filteredTable;      
      state.editedRows = [...new Set(filteredEditedRows)];
    },
    setEditedRows: (state, action) => {
      state.editedRows = action.payload;
    },
    setStepperStatus: (state, action) => {
      state.decisionStepperStatus = action.payload;
    },
    setPrevTableData: (state,action) => {
      state.prevTableData = action.payload
    },
    setPrevEditedRows: (state,action) => {
      state.prevEditedRows = action.payload
    }
  }
});

// Export actions for use in your components
export const {
  setRecommendationOptions,
  setTagUsers,
  setDecisionVotingTableData,
  handleDecisionMakingColumnsChange,
  setEditedRows,
  setStepperStatus,
  setPrevTableData,
  setPrevEditedRows
} = decisionCentralRulesSlice.actions;

// Export the reducer to be included in the store
export default decisionCentralRulesSlice.reducer;
